import { useServiceStore, useUserService } from "..";

export function usePermission(permission: string): boolean {
  const UserService = useUserService();

  return useServiceStore(UserService, (state) =>
    state.permissions.includes(permission)
  );
}
